import { Flex, Image, Text } from '@chakra-ui/react';
import { FoamLogo } from '~/components/icons';
import { convertPxToRems } from '~/utils-ts';

interface EmailAccessScreenHeaderProps {
  name: string;
  agencyName: string;
  agencyLogo: string;
}

export const EmailAccessScreenHeader: React.FC<
  EmailAccessScreenHeaderProps
> = ({ name, agencyName, agencyLogo }) => (
  <Flex alignItems={'center'} flexDirection={'column'} gap={2} marginBottom={6}>
    {agencyLogo ? (
      <Image src={agencyLogo} height={12} alt={name} />
    ) : (
      <FoamLogo color="primary.700" width={12} height={12} />
    )}
    <Text
      flex={1}
      fontSize="2xl"
      fontWeight={500}
      lineHeight={convertPxToRems(24)}
      overflow="hidden"
      justifyContent="center"
      textAlign="center"
      paddingX={6}
    >
      {agencyName ? agencyName : 'An Agency'} has shared with you {name}
    </Text>
  </Flex>
);
